import React, { useRef } from "react";
import "./PinPointsContainer.css";
import { useReactToPrint } from "react-to-print";
import PadDownloadPage from "../PdfDownloadPage/PdfDownloadPage";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/store/store";
import { generateHTMLContent } from "../../utils/helperFunctions";

interface Props {
  pinpoint: any[];
  userDetails: any;
}

const PinPointsContainer: React.FC<Props> = ({ pinpoint, userDetails }) => {
  // const contentRef = useRef<HTMLDivElement>(null);
  const token = useSelector(
    (state: RootState) => state?.auth.token
  );
  // console.log('userDetails===================>>',JSON.stringify(userDetails))
  const copyToClipboard = async (text: string) => {
    try {
      await navigator.clipboard.writeText(text);
      alert(`${text} copied to clipboard!`);
    } catch (err) {
      console.error("Failed to copy text: ", err);
    }
  };

  // const reactToPrintFn = useReactToPrint({ contentRef });

  const handlePrint = (pin: any, userDetails: any) => {
    const printWindow = window.open('', '_blank', `width=${window.innerWidth},height=${window.innerHeight}`);
    if (!printWindow) return;
  
    const html = generateHTMLContent(pin, userDetails, token);
  
    printWindow.document.write(html);
    printWindow.document.close();
  
    printWindow.onload = () => {
      printWindow.focus();
      printWindow.print();
      printWindow.close();
    };
  };

  return (
    <>
      {pinpoint.map((pin, index) => (
        <div className="pinpoint-outer" key={index}>
          <div className="pinpoint-copy">
            <h4>{pin.pinpoint_id}</h4>
            <img
              onClick={() => copyToClipboard(pin.pinpoint_id)}
              alt="copy"
              src={require("../../assets/images/copy.png")}
            />
            <img
              onClick={() => {
                // console.log('---->>>', pin)
                // contentRef.current = pin
                // reactToPrintFn();
                handlePrint(pin, userDetails)
              }}
              className="printer"
              alt="print"
              src={require("../../assets/images/printer.png")}
            />
          </div>
          <div className="bottom-container">
            <hr className="pinpoint-hr" />
            {token && <div className="pinpoint-name">
              <h4>{userDetails.name}</h4>
              <h5>{userDetails.username}</h5>
            </div>}

            <div className="pinpoint-address">
              <h4>Address</h4>
              <h5>
                {pin.flat_details}, {pin.area},
              </h5>
              <h5>
                {pin.city}, {pin.state}, {pin.country}, {pin.pin_code}
              </h5>
            </div>

            <div className="pinpoint-landmark">
              <h4>Landmark: <h5>{pin.landmark}</h5></h4>
              {!!pin.map_link && <h4>Map link: <a href={pin.map_link} target="_blank">{pin.map_link}</a></h4>}
            </div>
            <hr className="pinpoint-bottom-hr" />
          </div>

          {/* This component will be printed */}
          {/* <div style={{ display: "none" }}>
            <div className="pdf-container" ref={contentRef}>
              <PadDownloadPage pin={pin}  userDetails={userDetails}/>
            </div>
          </div> */}
        </div>
      ))}
    </>
  );
};

export default PinPointsContainer;
